import { Component, OnInit, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { LoadGeneralComponent } from '../../shared/components/common/load-general/load-general.component';
import { InputGeneralComponent } from '../../shared/inputs/input-general/input-general.component';
import { SnackbarService } from '../../shared/services/base/snackbar.service';
import { AuthService } from '../../shared/services/data/auth.service';
import { StorageService } from '../../shared/services/base/storage.service';

@Component({
  selector: 'app-login-new',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatIconModule,
    TranslatePipe,
    LoadGeneralComponent,
    InputGeneralComponent,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent implements OnInit {
  private authService = inject(AuthService);
  private snackbarService = inject(SnackbarService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private storage = inject(StorageService);
  private translateService = inject(TranslateService);

  hidePassword = signal(true);
  isLoading = signal(false);

  loginForm: FormGroup = new FormGroup({
    username: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    password: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
  });

  ngOnInit(): void {
    if (this.storage.isAuthenticated()) {
      const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/tickets';
      this.router.navigate([returnUrl]);
    }
  }

  togglePasswordVisibility(): void {
    this.hidePassword.update(v => !v);
  }

  login(): void {
    if (this.loginForm.invalid) {
      return;
    }

    this.isLoading.set(true);

    const { username, password } = this.loginForm.value as {
      username: string;
      password: string;
    };

    this.authService.login(username, password).subscribe({
      next: (response) => {
        this.isLoading.set(false);
        if (response?.Result === "CC00FF") {
          this.storage.set('token', response.Data);
          this.storage.set('username', response.Extra.Username);
          this.storage.set('email', response.Extra.Email);
          const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/tickets';
          this.router.navigate([returnUrl]);
        } else {
          this.snackbarService.error(this.translateService.instant('login.errorLogin'));
        }
      },
      error: () => {
        this.isLoading.set(false);
      }
    });
  }
}
